<template>
  <div class="success-container">
    <div class="success-card">
      <div class="icon-circle">✔</div>

      <h2 class="success-title">Booking Successful!</h2>
      <p class="success-subtitle">Thank you for your purchase</p>

      <div class="qr-section">
        <img :src="qrCodeUrl" alt="QR Code" class="qr-code" />
        <p class="booking-code-text">{{ bookingCode || "" }}</p>
        <p class="qr-text">
          Scan this QR at the counter to collect your ticket
        </p>
      </div>

      <!-- Payment Info -->
      <div class="payment-info final-summary">
        <template v-if="BookingDetails">
          <div class="final-summary-row">
            <span class="label">Movie:</span>
            <span class="value"
              >{{ BookingDetails && BookingDetails["movie_title"] }} |
              {{ BookingDetails && BookingDetails["lang_name"] }} |
              {{ BookingDetails && BookingDetails["mf_name"] }}</span
            >
          </div>

          <div class="final-summary-row">
            <span class="label">Show:</span>
            <span class="value">
              {{ BookingDetails.og_show_date | getDay }} |
              {{ dateParser(BookingDetails.og_show_date, "dateDigit") }}
              {{ dateParser(BookingDetails.og_show_date, "month") }} |
              {{ BookingDetails.og_show_time }}
            </span>
          </div>

          <div class="final-summary-row">
            <span class="label">Screen:</span>
            <span class="value">{{ BookingDetails.screen_name }}</span>
          </div>

          <div class="final-summary-row">
            <span class="label">Seats:</span>
            <span class="value">
              {{
                BookingDetails.seats && BookingDetails.seats.length
                  ? BookingDetails.seats.join(", ")
                  : ""
              }}
            </span>
          </div>
        </template>

        <div class="final-summary-row" v-if="FnbItems && FnbItems.length">
          <span class="label">F&B:</span>
          <span class="value">
            {{
              FnbItems.map(
                (item) =>
                  `${item["qty"] || item['fst_quantity'] || item["quantity"] || 1}x-${
                    item["title"] || item['fst_item_name'] || item["item_name"]
                  }`
              ).join(", ")
            }}
          </span>
        </div>

        <p class="d-flex justify-content-between final-amt-text">
          <strong>Total Paid:</strong>
          <strong
            >{{ curr_code }}
            {{ currFormat(grossAmount || 0) }}</strong
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import QRCode from "qrcode";

export default {
  name: "BookingSuccess",
  props: {
    BookingDetails: {
      type: Object,
    },
    bookingCode: String,
    yourTicket: String,
    finalAmountPaid: String,
    FnbItems: Array,
    curr_code: String,
  },
  data() {
    return {
      qrCodeUrl: null,
    };
  },
  computed: {
    grossAmount() {
      return parseFloat(this.finalAmountPaid || 0).toFixed(2);
    },
    ticketUrl() {
      return parseFloat(this.yourTicket || 0).toFixed(2);
    },
  },
  mounted() {
    setTimeout(() => {
      console.log('this.yourTicket', this.yourTicket);
      QRCode.toDataURL(this.yourTicket, { width: 200 }, (err, url) => {
        if (!err) this.qrCodeUrl = url;
        console.log('url', url);
        console.log('this.qrCodeUrl', this.qrCodeUrl);
      });
    }, 500);
  },
  methods: {
    dateParser(date, type) {
      if (type == "dateDigit") {
        return moment(new Date(date)).format("Do");
      } else if (type == "month") {
        return moment(new Date(date)).format("MMMM");
      }
    },
  },
};
</script>

<style scoped>
.booking-details {
  display: grid;
  gap: 10px;
  font-size: 14px;
  line-height: 1.6;
  background: #f9f9f9;
  padding: 15px;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
}

.final-summary-row {
  display: grid;
  grid-template-columns: 80px 1fr; /* label fixed, value flexible */
  align-items: center;
}

.final-summary .label {
  font-weight: 600;
  color: #444;
  font-size: 12px;
}

.final-summary .value {
  color: #222;
  font-weight: 500;
  font-size: 12px;
}

.final-amt-text {
  font-size: 18px;
  color: green;
}

.fs12 {
  font-size: 12px;
}

.success-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f7f9fc;
  padding: 20px;
}

.success-card {
  background: #fff;
  border-radius: 16px;
  padding: 30px 20px;
  max-width: 460px;
  width: 100%;
  text-align: center;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
  animation: fadeIn 0.6s ease;
}

.icon-circle {
  width: 78px;
  height: 78px;
  margin: 0 auto 15px;
  border-radius: 50%;
  background: #4caf50;
  color: white;
  font-size: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.success-title {
  font-size: 23px;
  font-weight: bold;
  margin-bottom: 5px;
  color: #222;
}

.success-subtitle {
  font-size: 16px;
  margin-bottom: 20px;
  color: #666;
}

.qr-section {
  margin: 20px 0;
}
.qr-code {
  width: 140px;
  height: 140px;
  object-fit: contain;
}
.qr-text {
  font-size: 14px;
  margin-top: 8px;
  color: #555;
}

.booking-code-text {
  font-size: 14px;
  margin-top: 2px;
  color: #555;
}

.payment-info {
  margin-top: 15px;
  text-align: left;
  font-size: 15px;
  background: #f9f9f9;
  padding: 12px;
  border-radius: 8px;
}

.payment-info p {
  margin: 4px 0;
}

.btn-home {
  margin-top: 20px;
  padding: 10px 18px;
  border: none;
  background: #4caf50;
  color: white;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.2s;
}
.btn-home:hover {
  background: #43a047;
}

/* Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
